import isUndefined from 'lodash/isUndefined.js';
import { clamp } from '../../utils/utils.js';

const types = [{
  name: 'px',
  regexp: new RegExp('^[-+]?[0-9]*.?[0-9]+px$')
}, {
  name: '%',
  regexp: new RegExp('^[-+]?[0-9]*.?[0-9]+%$')
}, {
  name: 'px',
  regexp: new RegExp('^[-+]?[0-9]*.?[0-9]+$')
}];
function getType(value) {
  if (value === 'auto') {
    return {
      type: value,
      value: 0
    };
  }
  for (let i = 0; i < types.length; i++) {
    const type = types[i];
    if (type.regexp.test(value)) {
      return {
        type: type.name,
        value: parseFloat(value)
      };
    }
  }
  return {
    type: '',
    value
  };
}
function parseSizeType(value) {
  switch (typeof value) {
    case 'number':
      return {
        type: 'px',
        value
      };
    case 'string':
      return getType(value);
    default:
      return {
        type: '',
        value
      };
  }
}
function clampValueToWindowOrMaxHeight(value, minHeight, maxHeight) {
  const height = getHeight(value);
  const max = Math.min(window.innerHeight, maxHeight);
  return clamp(height, minHeight, max);
}
function clampValueToWindowOrMaxWidth(value, minWidth, maxWidth) {
  const width = getWidth(value);
  const max = Math.min(window.innerWidth, maxWidth);
  return clamp(width, minWidth, max);
}
function getWidth(value) {
  const parsedWidth = parseSizeType(value);
  if (parsedWidth.type === '%') {
    return window.innerWidth / 100 * parsedWidth.value;
  }
  return parsedWidth.value;
}
function getHeight(value) {
  const parsedHeight = parseSizeType(value);
  if (parsedHeight.type === '%') {
    return window.innerHeight / 100 * parsedHeight.value;
  }
  return parsedHeight.value;
}
function getModalTopLeftPosition(_ref2) {
  let {
    pivotY,
    pivotX,
    trueModalWidth,
    trueModalHeight
  } = _ref2;
  const maxLeft = window.innerWidth - trueModalWidth;
  const maxTop = Math.max(0, window.innerHeight - trueModalHeight);
  const valueLeft = pivotX * maxLeft;
  const valueTop = pivotY * maxTop;
  return {
    left: parseInt(clamp(valueLeft, 0, maxLeft), 10),
    top: parseInt(clamp(valueTop, 0, maxTop), 10)
  };
}
function getBoundAttributes(node) {
  let {
    attrs
  } = node.data;
  const res = {};
  let {
    parent
  } = node;
  while (!isUndefined(parent)) {
    if (parent.componentOptions && parent.componentOptions.Ctor.options.inheritAttrs === false) {
      break;
    }
    if (!isUndefined(parent.data) && !isUndefined(parent.data.attrs)) {
      attrs = Object.assign(Object.assign({}, attrs), parent.data.attrs);
    }
    parent = parent.parent;
  }
  if (isUndefined(attrs)) {
    return;
  }
  for (const key in attrs) {
    if (key === 'style') {
      continue;
    }
    res[key] = attrs[key];
  }
  return res;
}

export { clampValueToWindowOrMaxHeight, clampValueToWindowOrMaxWidth, getBoundAttributes, getHeight, getModalTopLeftPosition, getWidth, parseSizeType };
//# sourceMappingURL=utils.js.map
